import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { getAllProduct } from "../../api/app";
import Footer from "../../components/layout/Footer";
import { truncate } from "../../utils/trunate";
import { useDispatch, useSelector } from "react-redux";
import cogoToast from "cogo-toast";
import { ADD_TO_CART } from "../../stores/cart";
import SEO from "../../components/layout/Seo";
import SlideShow from "../../components/layout/SlideShow";
import SearchInput from "../../components/layout/SearchInput";
import ProductCard from "../../components/layout/ProductCard";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";

const Products = (prop) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const carts = useSelector((state) => state.cart.products);

  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState(null);
  const [searchProduct, setSearchProduct] = useState("");

  useEffect(() => {
    getAllProduct().then((response) => {
      if (!response.error) {
        setProducts(response.payload);
        setLoading(false);
      }
    });
  }, []);

  const filteredProducts = products?.filter(
    (product) =>
      product.name.toLowerCase().includes(searchProduct.toLowerCase()) ||
      product.description.toLowerCase().includes(searchProduct.toLowerCase())
  );

  const onAddCart = (product) => {
    if (!auth.isAuthenticated) {
      prop.history.push("login");
    }

    let productItem = carts.find((result) => result._id === product._id);

    if (productItem !== undefined) {
      cogoToast.error("You already added this item to the cart basket.", {
        hideAfter: 3,
      });
      return false;
    }

    dispatch(
      ADD_TO_CART({
        products: [
          {
            _id: product._id,
            name: product.name,
            img: product.image_uri,
            ori_price: product.amount,
            description: product.description,
            price: product.amount,
            units: 1,
            quantity: 1,
          },
        ],
      })
    );

    cogoToast.success("Item has been added to the card.", { hideAfter: 3 });
  };

  const statusCart = (data) => {
    const cart = carts.find((item) => {
      return item._id === data._id;
    });

    return cart !== undefined ? "Added to Cart" : "Add to Cart";
  };

  return (
    <div>
      <SEO title="ZStudy | Products" description="Check our products" />
      {loading ? (
        <div className="h-screen flex item-center justify-center">
          <div className="loader">
            <BeatLoader color="#003074" size={20} />
          </div>
        </div>
      ) : (
        <div className="container">
          <SearchInput
            searchQuery={searchProduct}
            setSearchQuery={setSearchProduct}
            placeholder="Search products by name..."
          />
          {searchProduct.length <= 0 && (
            <div className="mt-10">
              <SlideShow type={"stem"} />
            </div>
          )}

          <div>
            <div className="text-xl font-semibold">Our Products</div>
            <div className="text-sm mt-2 font-medium text-gray-500 leading-6 mb-4">
              {" "}
              Choose from STEM kits with free delivery within lusaka, T & Cs
              Applied.
            </div>
          </div>
          {filteredProducts.length === 0 ? (
            <div className="flex flex-col items-center justify-center mt-10">
              <div>
                <MdOutlineProductionQuantityLimits className="text-8xl" />
              </div>
              <p className="text-center text-gray-600 text-lg">
                No products found matching your search.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {filteredProducts.map((product) => (
                <ProductCard
                  key={product._id}
                  product={product}
                  statusCart={statusCart}
                  onAddCart={onAddCart}
                />
              ))}
            </div>
          )}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Products;
